module.exports = __webpack_public_path__ + "img/Pedalsure-Logo_Large.48825a2.svg";